<ng-container [formGroup]="formGroup">
  <div class="section">
    <div class="section-header">
      <pdq-heading element="h5">Gift Message</pdq-heading>
      <div class="section-header__actions">
        <pdq-slide-toggle [formControl]="formGroup.get('giftMessage.enabled')"></pdq-slide-toggle>
        <pdq-button
          class="eye-preview-button"
          variant="empty"
          [icon]="activePreviewMode === PreviewMode.GiftBanner ? 'preview_eye' : 'preview_eye_crossed'"
          [iconColor]="
            activePreviewMode === PreviewMode.GiftBanner ? 'var(--primary-default)' : 'var(--on-surface-light)'
          "
          (click)="previewToggle.emit()">
        </pdq-button>
      </div>
    </div>
    @if (displayDesignConfigurationSections) {
      <div class="controls-wrapper">
        <pdq-input [formControl]="formGroup.get('giftMessage.title')" label="Display Title"></pdq-input>
        <pdq-input [formControl]="formGroup.get('giftMessage.text')" label="Display Subtitle"></pdq-input>
        <div class="flex-row">
          <pdq-input
            [formControl]="formGroup.get('giftMessage.actionButtonText')"
            label="Button Display Text"></pdq-input>
          <pdq-dropdown
            [formControl]="formGroup.get('giftMessage.buttonAppearance')"
            title="Button Appearance"
            [options]="buttonAppearanceOptions"
            optionLabel="label"
            optionValue="value"></pdq-dropdown>
        </div>
        <pdq-input-file
          fileType="img"
          label="Gift icon"
          tooltip=".png, maximum size 500KB"
          variant="optionlist"
          maxKBSize="500"
          [allowClear]="false"
          [initialImage]="defaultIconUrl"
          [value]="formGroup.get('giftMessage.icon').value"
          (onPreviewChange)="formGroup.get('giftMessage.icon').setValue($event)"></pdq-input-file>

        <div class="advanced-styling-container">
          <span class="subtitle-small">Advanced styling</span>
          <span class="subtitle-small">Main background</span>
          <extension-appearance-style [formGroup]="formGroup.get('giftMessageStyle')"> </extension-appearance-style>
        </div>
      </div>
    }
  </div>
</ng-container>
